import { useState } from "react";
import { FiSearch } from "react-icons/fi";
import AllAppointmentList from "../DoctorComponent.jsx/Tables/AllAppointmentList";
import AllPharmacyDetails from "./AllPharmacyDetails";
import SupplierMaster from "./SupplierMaster";
import PurchaseOrder from "./PurchaseOrder";
import GoodsReceipt from "./GoodsReceipt";
import ProcurementDetails from "./ProcurementDetails";

const ProcurementTabs = () => {
  const [activeTab, setActiveTab] = useState("allmedicines");

  // ✅ Mock Appointment Data
  const appointmentData = [
  {
    id: 1,
    medicineName: "Paracetamol",
    Category: "General Medicine",
    date: "2025-08-20",
    stock: "50 strips",
    status: "Available",
  },
  {
    id: 2,
    medicineName: "Amoxicillin",
    Category: "Antibiotics",
    date: "2025-08-18",
    stock: "20 bottles",
    status: "LowStock",
  },
  {
    id: 3,
    medicineName: "Ibuprofen",
    Category: "Pain Relief",
    date: "2025-08-10",
    stock: "Out of Stock",
    status: "Unavailable",
  },
  {
    id: 4,
    medicineName: "Cetirizine",
    Category: "Allergy",
    date: "2025-08-25",
    stock: "80 strips",
    status: "Available",
  },
  {
    id: 5,
    medicineName: "Metformin",
    Category: "Diabetes",
    date: "2025-08-22",
    stock: "30 bottles",
    status: "Available",
  },
];


  const tabButtonStyle = (key) =>
    `inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${
      activeTab === key
        ? "bg-white text-black shadow-sm"
        : "text-muted-foreground hover:text-black"
    }`;

  return (
    <div className="space-y-4">
      {/* Tabs */}
      <div className="flex items-center justify-between mb-4">
        <div className="bg-[#f5f5f5] inline-flex flex-wrap items-center rounded-md p-1 text-muted-foreground mt-3">
          <button
            onClick={() => setActiveTab("allmedicines")}
            className={tabButtonStyle("allmedicines")}
          >
          Supplier Master
          </button>
          <button
            onClick={() => setActiveTab("lowstockmedicines")}
            className={tabButtonStyle("lowstockmedicines")}
          >
           Purchase Order
          </button>
          <button
            onClick={() => setActiveTab("unavailablestock")}
            className={tabButtonStyle("unavailablestock")}
          >
           Goods Receipt / Tracking
          </button>
          <button
            onClick={() => setActiveTab("availablestock")}
            className={tabButtonStyle("availablestock")}
          >
            Details
          </button>
        </div>

        {/* Search */}
        <div className="flex flex-wrap gap-2 items-center">
          <div className="relative">
            <FiSearch className="absolute left-3 top-2.5 h-4 w-4 text-[#00C335]" />
            <input
              type="search"
              placeholder="Search Medicines..."
              className="w-full pl-10 pr-4 py-2 h-10 rounded-full border border-gray-300 placeholder:text-gray-500 text-sm focus:outline-none focus:ring-2 focus:ring-[#00C335] transition"
            />
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="p-2 border rounded-lg bg-white shadow-sm mb-5">
        {activeTab === "allmedicines" && (
          <SupplierMaster />
        )}
        {activeTab === "lowstockmedicines" && (
          <PurchaseOrder  />
        )}
        {activeTab === "unavailablestock" && (
          <GoodsReceipt/>
        )}
        {activeTab === "availablestock" && (
          // <AllPharmacyDetails
          //   data={appointmentData.filter((a) => a.status === "Available")}
          // />
          <ProcurementDetails/>
        )}
      </div>
    </div>
  );
};

export default ProcurementTabs;
